import ContractorInterface from "../../../common/interfaces/ContractorInterface";
import { deleteDossier, deleteDossierId } from "../../../app/rootReducer";
import { fundingTypeEnum } from "../../../common/constants/fundingTypeEnum";
import { AppDispatch } from "../../../app/store";

interface Props {
    dispatch: AppDispatch;
    contractors?: object[];
    activeContractorId?: number | null;
    slug?: string;
}

export const handleContractorProceed = (props: Props): void => {
    const { dispatch, contractors, activeContractorId, slug } = props;

    if (!slug) return;
    const localDossierUuidKey = slug + "-dossier_uuid";
    const localDossierAccessTokenKey = slug + "-dossier_access_token";
    const dossierUuid = (
        localStorage.getItem(localDossierUuidKey) || ""
    ).toString();

    const selected = contractors?.find(
        (c: ContractorInterface) => c.id === (activeContractorId ?? -1),
    ) as ContractorInterface | undefined;
    const redirectUrl = selected?.redirect_url ?? null;

    dispatch(
        deleteDossier({
            dossierUuid: dossierUuid,
            fundingType: fundingTypeEnum.Unknown,
        }),
    ).finally(() => {
        dispatch(deleteDossierId());
        localStorage.removeItem(localDossierUuidKey);
        localStorage.removeItem(localDossierAccessTokenKey);
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    });
};
